import React from 'react';
import { getNextHourOrEndOfDay } from 'Components/widgets/additional-transports/additional-transports-filters/ArrivalDepartureRangeFilter.utils';
import { applyFilters, defaultState } from './transportFiltersReducer.utils';
type TransportFiltersActionsType = 'INIT' | 'UPDATE' | 'RESET';
export const TRANSPORT_FILTERS_ACTIONS = {
  UPDATE: 'UPDATE',
  RESET: 'RESET',
};
export const transportFiltersReducer = (
  state: TransportFiltersState,
  action: {
    type: TransportFiltersActionsType;
    payload: {
      transports?: Array<AlternativeTransport>;
      value: string | TransportDateRange;
      key: TransportFiltersKeys;
    };
  },
) => {
  const { payload } = action;

  switch (action.type) {
    case TRANSPORT_FILTERS_ACTIONS.UPDATE: {
      const { value, key } = payload;
      const filters = state[key];
      const updatedFilter = ['inboundDepartureTimeRange', 'outboundDepartureTimeRange'].includes(
        key,
      )
        ? value // @ts-expect-error TODO(flow-migration)
        : filters.map((filter) => {
            if (filter.value === value) {
              return { ...filter, isSelected: !filter.isSelected };
            }

            return filter;
          });
      const newState: TransportFiltersState = {
        ...state,
        [key]: updatedFilter,
      };
      const { filteredTransports, totalFiltersSelected } = applyFilters(newState);
      return { ...newState, filteredTransports, totalFiltersSelected };
    }

    case TRANSPORT_FILTERS_ACTIONS.RESET: {
      const { transports, stopovers, durationRanges, companies, connectingCities } = state;
      const newState: TransportFiltersState = {
        ...state,
        filteredTransports: transports,
        stopovers: stopovers.map((stopover) => ({ ...stopover, isSelected: false })),
        durationRanges: durationRanges.map((durationRange) => ({
          ...durationRange,
          isSelected: false,
        })),
        companies: companies.map((company) => ({ ...company, isSelected: false })),
        connectingCities: connectingCities.map((connectingCity) => ({
          ...connectingCity,
          isSelected: false,
        })),
        inboundDepartureTimeRange: {
          start: (state.defaultInboundDepartureTimeRange || defaultState.inboundDepartureTimeRange)
            .start,
          end: getNextHourOrEndOfDay(
            (state.defaultInboundDepartureTimeRange || defaultState.inboundDepartureTimeRange).end,
          ),
        },
        outboundDepartureTimeRange: {
          start: (
            state.defaultOutboundDepartureTimeRange || defaultState.outboundDepartureTimeRange
          ).start,
          end: getNextHourOrEndOfDay(
            (state.defaultOutboundDepartureTimeRange || defaultState.outboundDepartureTimeRange)
              .end,
          ),
        },
        totalFiltersSelected: 0,
      };
      return newState;
    }

    default:
      throw new Error();
  }
};
